// from https://github.com/g13n/ua.js/blob/master/src/ua.js
function test(pattern) {
    var userAgent = navigator.userAgent || '';
    return pattern.test(userAgent);
}
function detect(pattern) {
    return function () {
        return test(pattern);
    };
}
/**
 * 是否是微信环境（非企业微信）
 */
export var isWeixin = function () { return test(/micromessenger/i) && !test(/wxwork/gi); };
/** 是否是微博环境 */
export var isWeibo = detect(/weibo/i);
/** 是否是小米浏览器 */
export var isXiaomi = detect(/xiaomi/i);
/** 是否是百度浏览器或者手机百度 */
export var isBaidu = detect(/baiduboxapp|baidubrowser/i);
/** 是否是iOS */
export var isIOS = detect(/iphone|ipad|ipod/i);
/** 是否是iPhoneX */
export var isIphoneX = function () {
    return test(/iphone/i) && (screen.height === 812 && screen.width === 375);
};
/** 是否是Android */
export var isAndroid = detect(/android/i);
/** 是否是移动端 */
export var isMobile = detect(/(iphone|ipod|((?:android)?.*?mobile)|blackberrynokia)/i);
/** 是否是豆瓣 App */
export var isFrodo = detect(/com\.douban\.frodo/i);
/** 是否是微信小程序 */
export var isMiniProgram = detect(/miniprogram/i);
/** 是否是 pre 版 App */
export var isFrodoPre = detect(/(com\.douban\.frodo\/[\d.]+(dev|debug|test|beta|alpha))|(com\.douban\.frodo\.test)/i);
/** 是否是鸿蒙 */
export var isHarmony = detect(/com\.douban\.frodo\.hap/i);
/**
 * UA 判断工具函数
 */
export var UA = {
    isWeixin: isWeixin,
    isWeibo: isWeibo,
    isXiaomi: isXiaomi,
    isBaidu: isBaidu,
    isIOS: isIOS,
    isIphoneX: isIphoneX,
    isAndroid: isAndroid,
    isMobile: isMobile,
    isFrodo: isFrodo,
    isMiniProgram: isMiniProgram,
    isFrodoPre: isFrodoPre,
    isHarmony: isHarmony,
};
//# sourceMappingURL=ua.js.map